import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconKeyboardArrowDown.tsx
const OutlinedFilledKeyboardArrowDown = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z" })
});
const OutlinedKeyboardArrowDown = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z" })
});
const RoundedFilledKeyboardArrowDown = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-339q-9 0-18-4t-16-11L249-551q-14-14-13.5-33.5T250-618q14-14 33.5-14t33.5 14l163 164 164-164q14-14 33-13.5t33 14.5q14 14 14 33.5T710-550L514-354q-7 7-16 11t-18 4Z" })
});
const RoundedKeyboardArrowDown = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-339q-9 0-18-4t-16-11L249-551q-14-14-13.5-33.5T250-618q14-14 33.5-14t33.5 14l163 164 164-164q14-14 33-13.5t33 14.5q14 14 14 33.5T710-550L514-354q-7 7-16 11t-18 4Z" })
});
const SharpFilledKeyboardArrowDown = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z" })
});
const SharpKeyboardArrowDown = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-320 216-584l67-67 197 197 197-197 67 67-264 264Z" })
});
const componentMap = {
	outlined: OutlinedKeyboardArrowDown,
	"outlined-fill": OutlinedFilledKeyboardArrowDown,
	rounded: RoundedKeyboardArrowDown,
	"rounded-fill": RoundedFilledKeyboardArrowDown,
	sharp: SharpKeyboardArrowDown,
	"sharp-fill": SharpFilledKeyboardArrowDown
};
const IconKeyboardArrowDown = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconKeyboardArrowDown };